<div class="c__social-links">
  <p role="heading" class="is-visually-hidden" aria-level="2">
    {{ 'navigation.socialMedia.followUs' | translate }}
  </p>

  @if (data.length > 0) {
    <ul sd-list-inline class="{{isMobile$ ? 'is-xl' : 'is-xxl'}}">
      @for (item of data; track item.icon) {
        <li>
          <sd-link
            [icon]="item.icon"
            [size]="iconSize.medium"
            [link]="item.link"
            rel="nofollow"
            [buttonIconTitle]="('navigation.socialMedia.a11y.brandOn' | translate) + ' ' + item.link.linkName"
            [titleHidden]="true"
            [ariaLabel]="item.buttonIconTitle"
            [brand]="brand"
          />
        </li>
      }
    </ul>
  }
</div>
